import React from "react";
import { Box, Button, Flex, Text, VStack, Icon } from "@chakra-ui/react";
import { FaFilter, FaRedo } from "react-icons/fa";
import Filter from "./Filter/AllFilter";

const LeftSidebar = (props) => {
  const { value, getCheckboxProps, setPriceRange, priceRange } = props;

  const handleClearFilters = () => {
    localStorage.removeItem("subcatname");
    localStorage.removeItem("selectedLanguage");
    window.location.reload();
  };

  return (
    <Box w="18rem" bg="#FFFFFF" border="1px solid #E2E8F0" rounded="xl" shadow="sm" overflow="hidden">
      <VStack align="stretch" spacing="0">
        <Box px="4" py="3.5" borderBottom="1px solid #F1F5F9" bg="#F8FAFC">
          <Flex align="center" justify="space-between">
            <Flex align="center" gap="2">
              <Icon as={FaFilter} color="yellow.600" boxSize="13px" />
              <Text fontSize="14px" fontWeight="700" color="gray.800" textTransform="uppercase" letterSpacing="0.5px">
                Filters
              </Text>
            </Flex>

            <Button
              size="xs"
              variant="ghost"
              color="#2563EB"
              _hover={{ bg: "blue.50" }}
              leftIcon={<Icon as={FaRedo} boxSize="10px" />}
              onClick={handleClearFilters}
              fontWeight="600"
            >
              Reset
            </Button>
          </Flex>
        </Box>

        <Box p="2">
          <Filter
            getCheckboxProps={getCheckboxProps}
            setPriceRange={setPriceRange}
            priceRange={priceRange}
          />
        </Box>
      </VStack>
    </Box>
  );
};

export default LeftSidebar;